import React from "react";
import HeroSection from "../../sections/HeroSection/HeroSection";
import PufferySection from "../../sections/PufferySection/PufferySection";
import ServicesSection from "../../sections/ServicesSection/ServicesSection";
import CrewSection from "../../sections/CrewSection/CrewSection";
import ReservationStrip from "../../components/ReservationStrip/ReservationStrip";

import aboutBg from "../../assets/DimoraImages/IMG_9736.jpg";   // 👈 import here

const AboutPage = () => {
  return (
    <>
      <HeroSection backgroundImage={aboutBg} />
      <PufferySection />
      <CrewSection />
      <ServicesSection />
      <ReservationStrip />
    </>
  );
};

export default AboutPage;
